/* eslint-disable @stencil-community/required-jsdoc */
import { Component, State, h, Listen, Prop, getAssetPath, Element } from '@stencil/core';
import {
  renderShimmer,
  renderUserMessage,
  smoothScrollIntoView,
  parseFromStringToHtml,
  renderMainMenuMarkup,
  renderLoader,
  renderBotMessage,
  toggleChatBox,
  renderButton,
  renderMainMenuLink,
  renderContactUs,
  renderBotMainMenu,
  renderConfirmationDialogue,
  renderBotWelcomeMessage,
  minimizeChatbox,
  a11yLabels,
  renderSuggestedQuestionsHeader,
  defaultDataJson,
  parseFromStringToHtmlElement,
  startMainMenuCounter
} from './chat-utils';
import { generateRandomId } from '@utils/utils';
import { htmlSanitizer } from '@utils/html-sanitizer';

export type loaderType = 'bubbles' | 'skeleton';

@Component({
  tag: 'vs-chatbot',
  styleUrls: ['chatbot.css', 'shimmer.css'],
  shadow: false,
  assetsDirs: ['assets'],
})
export class VisaChatbot {
  @Element() el: HTMLVsChatbotElement;
  @Prop() url?: any = '';
  @Prop() feedbackurl?: any = '';
  // eslint-disable-next-line @stencil-community/strict-mutable
  @Prop({ mutable: true }) datajson: any;
  @Prop() loaderType?: loaderType = 'bubbles';
  @State() messages: Array<{ role: string; content: string }> = [];
  @State() chatBoxVisible: Boolean = false;
  @State() animationClass = '';
  @State() isLoading = false;
  @State() answerSource: any = '';
  @State() isContentVisible = false;
  @State() source = [];
  @State() uniqueSource = [];
  @State() disableChatButton = false;
  @State() showEndChatScreen = false;
  @State() isMinimized = false;
  @State() chatInputVal = '';
  @State() isApiAuthorized = false;
  @State() userInputArr: Array<any> = [];
  @State() chatExpansionData = 'chat-closed';
  @State() textAreaOverflow = false;

  // /* eslint-disable-next-line @typescript-eslint/no-unused-vars */
  chatContainerElement?: any;
  private textInput?: HTMLInputElement;
  private lastUserMessage = '';
  private chatContainer?: HTMLElement;
  private chatMainMenuTimerObj: any;
  private jsonObject: any;
  private endChatButton: HTMLButtonElement;
  private tabKeyPressed = false;
  private chatbotAllyLabels: any;
  private isDisclaimerOpen = true;

  componentWillLoad() {
    const params = new URLSearchParams(window.location.search);
    const myParam = params.get('q');
    if (!this.datajson) {
      this.datajson = JSON.stringify(defaultDataJson);
    }
    this.jsonObject = JSON.parse(this.datajson);
    if (this.jsonObject.chatBotAllyLabels) {
      this.chatbotAllyLabels = this.jsonObject.chatBotAllyLabels;
    } else {
      this.chatbotAllyLabels= {};
      this.chatbotAllyLabels.botNameAllyLabel = a11yLabels.BOT_NAME;
      this.chatbotAllyLabels.chatWindowAllyLabel = a11yLabels.CHAT_WINDOW;
      this.chatbotAllyLabels.minimizeButtonAllyLabel = a11yLabels.MINIMIZE_BUTTON;
      this.chatbotAllyLabels.closeButtonAllyLabel = a11yLabels.CLOSE_BUTTON;
      this.chatbotAllyLabels.clearMessageButtonAllyLabel = a11yLabels.CLEAR_MESSAGE_BUTTON;
      this.chatbotAllyLabels.sendMessageButtonAllyLabel = a11yLabels.SEND_MESSAGE_BUTTON;
      this.chatbotAllyLabels.likeButtonAllyLabel = a11yLabels.LIKE_BUTTON;
      this.chatbotAllyLabels.dislikeButtonAllyLabel = a11yLabels.DISLIKE_BUTTON;
      this.chatbotAllyLabels.respondingActionButtonAllyLabel = a11yLabels.RESPONDING_ACTION;
      this.chatbotAllyLabels.ongoingChatAllyLabel = a11yLabels.ONGOING_CHAT;
      this.chatbotAllyLabels.disclaimerChatAllyLabel = a11yLabels.DISCLAIMER_CHAT;
    }
    if (myParam === 'test') {
      this.isApiAuthorized = true;
      return;
    }
    fetch(`${this.url?.substring(0, this.url?.indexOf('?'))}`, {
      method: 'POST',
    })
      .then(() => {
        this.isApiAuthorized = true;
      })
      .catch(() => {
        this.isApiAuthorized = false;
      });
  }

  // START GENAI@CHATGPT4
  componentDidLoad() {
    const mainElement = document.querySelector('main');
    if (mainElement && mainElement.firstChild !== this.el) {
      mainElement.insertBefore(this.el, mainElement.firstChild);
    }
    // START GENAI@CHATGPT4
    document.addEventListener('keydown', event => {
      if (event.key === 'Escape') {
        if (this.chatBoxVisible) {
          minimizeChatbox(this);
        }
      }
    });
  }

  // START GENAI@CHATGPT4
  private handleChatFocusTrap = event => {
    if (this.tabKeyPressed && this.chatExpansionData === 'chat-open') {
      setTimeout(() => {
        const chatContainer = this.chatContainerElement;
        const minBtn = this.el.querySelector<HTMLElement>('.vs-minimize-icon');
        const inputArea = this.el.querySelector<HTMLElement>('.chat-input'); // Selecting input with class Y

        if (!chatContainer.contains(event.relatedTarget)) {
          event.preventDefault();
          if (event.target === minBtn) {
            // If focus is moving out from the minimize button
            inputArea.focus(); // Focus the input with class Y
          } else {
            minBtn.focus();
          }
        }
      }, 0);
    }
  };
  // END GENAI@CHATGPT4

  // END GENAI@CHATGPT4
  // eslint-disable-next-line @stencil-community/prefer-vdom-listener
  @Listen('keydown')
  handleKeyDown(ev: KeyboardEvent) {
    if (ev.key === 'Enter') {
      this.sendMessage();
    }
    if (ev.key === 'Tab') {
      this.tabKeyPressed = true;
    }
  }

  private sendMessage = () => {
    // e.preventDefault();
    if (this.textInput.value) {
      var chatTrackingEvent = new CustomEvent('chat_tracking_internal', {
        detail: {
          componentType: 'button',
          eventAction: 'chat user asked questions',
          component: 'chat assistant',
          siteSection: 'others',
          clickText: this.textInput.value,
        },
      });
      document.dispatchEvent(chatTrackingEvent);
      this.isLoading = true;
      const userInputs = [...this.userInputArr];
      userInputs.push(this.textInput.value.toLowerCase().replace(/\?$/, ''));
      this.userInputArr = userInputs;

      // START GENAI@CHATGPT4
      const randomNo = generateRandomId();
      this.lastUserMessage = this.textInput.value;
      const userHtmlMarkup = renderUserMessage(randomNo, this.textInput.value);
      this.chatContainer.appendChild(parseFromStringToHtml(userHtmlMarkup));
      const elem = document.getElementById(`${randomNo}`);
      setTimeout(() => smoothScrollIntoView(elem), 0);
      const loaderMarkup = this.loaderType === 'bubbles' ? renderLoader(this.chatbotAllyLabels.respondingActionButtonAllyLabel) : renderShimmer();
      this.chatContainer.appendChild(parseFromStringToHtml(loaderMarkup));
      const loaderElem = document.getElementById('loader');
      setTimeout(() => smoothScrollIntoView(loaderElem), 0);
      this.fetchResponse(this.textInput.value.trim());
    }
    this.textInput.value = '';
    this.chatInputVal = '';
    this.textAreaOverflow = false;
  };

  private fetchResponse = async (searchStr = '') => {
    this.isLoading = true;
    let isDOMCreated = false;
    const encodedSearchStr = encodeURI(searchStr);
    const sessionId = localStorage.getItem('visaAssistSessionId');
    let decodedUrl = decodeURIComponent(this.url);

    // Extract the query string from the URL
    let urlObj = new URL(decodedUrl);
    let queryString = urlObj.search + `&searchString=${encodedSearchStr}&sessionId=${sessionId}`;
    const url = urlObj.origin + urlObj.pathname;
    let params = new URLSearchParams(queryString);
    // Convert URLSearchParams to an object using Object.fromEntries
    let paramsObj = Object.fromEntries(params);

    await fetch(url, {
      method: 'POST',
      body: JSON.stringify(paramsObj),
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
      },
    })
      .then(response => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const reader = response.body.getReader();
        const decoder = new TextDecoder('utf-8');
        const processText = async ({ done, value }) => {
          console.log(done);
          let res = JSON.parse(decoder.decode(value));
          this.isLoading = false;
          const randomNo = Math.random();
          const { questions } = res;
          const insertBotResponse = () => {
            if (!isDOMCreated) {
              this.chatContainer.insertAdjacentHTML(
                'beforeend',
                `<div class="message chatbot" > <p id=${randomNo} class="vs-bot-response transition">${res.response.response}</p>
             </div>`,
              );
            }
            isDOMCreated = true;
            const element = document.getElementById(`${randomNo}`);
            setTimeout(() => smoothScrollIntoView(element?.parentElement), 50);
          };
          if (res.successMessage === 'Success') {
            insertBotResponse();
            const loaderElem = document.querySelector('.loader');
            if (loaderElem) {
              loaderElem.remove();
            }
            let cardDiv = document.createElement('div');

            if (questions?.length || (res?.urlMap && Object.keys(res?.urlMap).length)) {
              const chatFeedbackMarkup = `<vs-chat-feedback chat-id='${generateRandomId()}' url='${this.feedbackurl}' uuid='${res.id}' session-id='${res.sessionId}'></vs-chat-feedback>`;
              cardDiv.appendChild(parseFromStringToHtml(chatFeedbackMarkup));
            }
            if (res?.urlMap && Object.keys(res?.urlMap).length) {
              cardDiv.classList.add('sources');
              const accordion = `<vs-accordion accordion-item-id='${generateRandomId()}' content='${JSON.stringify(res.urlMap)}' contentType='anchors' heading="${this.jsonObject.sourcesText
              }"></vs-accordion>`;
              cardDiv.appendChild(parseFromStringToHtml(accordion));
              let messagesDOM = document.querySelector('.chat-history');
              let lastElem = messagesDOM.lastElementChild;
              const elem = lastElem.querySelector('.vs-bot-response');
              elem.append(cardDiv);
              setTimeout(() => smoothScrollIntoView(elem), 0);
              messagesDOM = document.querySelector('.chat-history');
              lastElem = messagesDOM.lastElementChild;
              setTimeout(() => smoothScrollIntoView(lastElem), 0);
            }
            if (questions && questions?.length) {
              let suggestedQuestionsHeader = renderSuggestedQuestionsHeader(this.jsonObject.suggestedHelpQuestions);
              const DOMH2Elem = parseFromStringToHtml(suggestedQuestionsHeader);
              cardDiv.appendChild(DOMH2Elem);
              questions.forEach((question: any) => {
                let isQuestionIncluded = false;
                if (question && question !== 'Response') {
                  const q = question?.replace(/^\d+[\.)]\s*/, '');
                  this.userInputArr.forEach(val => {
                    if (val.includes(q.toLowerCase().trim().replace(/\?$/, ''))) {
                      isQuestionIncluded = true;
                    }
                  });
                  if (!isQuestionIncluded) {
                    let button = renderButton(q);
                    // Replace the class name in the button HTML to show the search icon for the suggested questions
                    button = button.replace(/visa-icon-search-md/g, 'visa-icon-search');
                    const DOMElem = parseFromStringToHtml(button);
                    DOMElem.addEventListener('click', () => this.handleSuggestionClick(q));
                    cardDiv.appendChild(DOMElem);
                  }
                }
              });
              let messagesDOM = document.querySelector('.chat-history');
              let lastElem = messagesDOM.lastElementChild;
              const elem = lastElem.querySelector('.vs-bot-response');
              elem.append(cardDiv);
            }

            if (this.jsonObject.contactSalesUrl && this.jsonObject.contactSalesText) {
              let contactUsBtn = renderContactUs(this.jsonObject.contactSalesUrl, this.jsonObject.contactSalesText);
              cardDiv.appendChild(parseFromStringToHtml(contactUsBtn));
            }

            const mainMenuLink = parseFromStringToHtml(renderMainMenuLink(this.jsonObject.mainMenuLinkText));
            mainMenuLink.addEventListener('click', () => renderBotMainMenu(this));

            cardDiv.appendChild(mainMenuLink);
            const element = document.getElementById(`${randomNo}`);
            setTimeout(() => smoothScrollIntoView(element?.parentElement), 50);
            setTimeout(() => {
              const chatInp = document.querySelector<HTMLElement>('.chat-input');
              chatInp.focus();
            }, 300);
            if (res.sourcesFound != 'true') {
              this.emitNoResultsTrackingEvent();
            }
          } else {
            this.emitNoResultsTrackingEvent();
          }
          return res;
        };
        reader.read().then(processText);
        this.textInput.focus();
      })
      .catch(() => {
        const loader = document.getElementById('loader');
        this.isLoading = false;
        this.emitNoResultsTrackingEvent();

        if (loader) {
          loader.remove();
          const randomErrorId = generateRandomId();
          this.chatContainer.insertAdjacentHTML(
            'beforeend',
            `<div class="message chatbot"><p id=${randomErrorId} class="vs-bot-response transition">${this.jsonObject.chatbotErrorMsg}</p>
                           </div>`,
          );
          const element = document.getElementById(`${randomErrorId}`);
          setTimeout(() => smoothScrollIntoView(element?.parentElement), 50);
        }
      });
  };

  private renderchatIcon = (customClass = '') => {
    const imageSrc = getAssetPath(`./assets/chat.svg`);
    return <img class={`vs-chat-svg ${customClass}`} src={imageSrc} alt="" />;
  };

  private renderSendIcon = (customClass = '') => {
    const imageSrc = getAssetPath(`./assets/send.svg`);
    return <img class={`vs-send-svg ${customClass}`} src={imageSrc} alt="" />;
  };

  private handleSuggestionClick = val => {
    this.textInput.value = val;
    this.chatInputVal = val;
    const enterBtn: any = document.querySelector('.vs-chat-enter');
    if (enterBtn) {
      setTimeout(() => {
        enterBtn.click();
      }, 200);
    }
  };

  private handleMainMenuClickEvents = e => {
    const index = e.target.getAttribute('data-type');
    let chatMenuItems;
    if (this.jsonObject.mainMenuItems) {
      chatMenuItems = this.jsonObject.mainMenuItems[index];
      renderMainMenuMarkup(this.chatContainer, chatMenuItems, this.chatbotAllyLabels.botNameAllyLabel);
    }
    e.target.parentElement.classList.add('vs-disabled-action');
    const parent = e.target.parentElement;
    const chatOptionsElements = Array.from(parent.querySelectorAll('.vs-chat-options'));
    chatOptionsElements.forEach(el => {
      (el as HTMLElement).tabIndex = -1;
    });
    e.target.parentElement.closest('.chatbot').removeEventListener('click', this.handleMainMenuClickEvents);
    if (chatMenuItems && chatMenuItems.disableNextSteps === 'false') {
      setTimeout(() => renderConfirmationDialogue(this), 1000);
    }
  };

  private handleConfirmationDialogue = (e, shouldFocusInput = true) => {
    // START GENAI@CHATGPT4
    const attrVal = e.target.getAttribute('data-val') == 'true' ? 'Yes' : 'No';
    const attrValStr = e.target.getAttribute('data-val') == 'true' ? `${this.jsonObject.acceptOption}` : `${this.jsonObject.declineOption}`;
    e.target.parentElement.classList.add('vs-disabled-action');
    const parent = e.target.parentElement;
    const chatOptionsElements = Array.from(parent.querySelectorAll('.vs-chat-selection'));
    chatOptionsElements.forEach(el => {
      (el as HTMLElement).tabIndex = -1;
    });
    if (shouldFocusInput) {
      setTimeout(() => {
        const chatInp = document.querySelector<HTMLElement>('.chat-input');
        chatInp.focus({ preventScroll: true });
      }, 600);
    }
    const closestResponse = e.target.parentElement.closest('.chatbot');
    const clickHandlerElem = closestResponse?.querySelector('.vs-chat-box-element');
    clickHandlerElem?.removeEventListener('click', this.handleConfirmationDialogue);
    const randomId = generateRandomId();
    const markup = parseFromStringToHtml(renderUserMessage(randomId, attrValStr));
    this.chatContainer.appendChild(markup);
    setTimeout(() => smoothScrollIntoView(markup), 0);
    setTimeout(() => smoothScrollIntoView(markup), 0);
    let botMarkup: any;
    if (attrVal === 'Yes') {
      botMarkup = parseFromStringToHtml(renderBotMessage(this.jsonObject.acceptOptionResponse, this.chatbotAllyLabels.botNameAllyLabel));
    } else {
      botMarkup = parseFromStringToHtml(renderBotMessage(this.jsonObject.declineOptionResponse, this.chatbotAllyLabels.botNameAllyLabel));
    }
    this.chatContainer.appendChild(botMarkup);
    const mainMenuLink = parseFromStringToHtml(renderMainMenuLink(this.jsonObject.mainMenuLinkText));
    mainMenuLink.addEventListener('click', () => renderBotMainMenu(this));
    const elem = this.chatContainer.lastElementChild.querySelector('.vs-bot-response');
    elem.appendChild(mainMenuLink);
    setTimeout(() => smoothScrollIntoView(elem, 'end'), 1000);
    // END GENAI@CHATGPT4
  };

  // START GENAI
  private handleChatClose = () => {
    let eventDetail;

    if (this.isDisclaimerOpen) {
      // Close the chat directly if the disclaimer is open
      eventDetail = {
        componentType: 'button',
        eventAction: 'close chat',
        component: 'chat assistant',
        siteSection: 'others',
        clickText: 'close chat',
      };
      toggleChatBox(this);
      const chatBotButton = document.querySelector<HTMLElement>('.vs-chat-main-container .vs-sticky-button');
      chatBotButton.focus();
    } else if (this.showEndChatScreen) {
      // Handle the end chat action
      eventDetail = {
        componentType: 'button',
        eventAction: 'end chat',
        component: 'chat assistant',
        siteSection: 'others',
        clickText: 'end chat',
      };
      toggleChatBox(this);
      const chatBotButton = document.querySelector<HTMLElement>('.vs-chat-main-container .vs-sticky-button');
      chatBotButton.focus();
    } else {
      // Prepare to show the end chat message
      eventDetail = {
        componentType: 'button',
        eventAction: 'close chat',
        component: 'chat assistant',
        siteSection: 'others',
        clickText: 'close chat',
      };
      this.showEndChatScreen = true; // Set to true to show the end chat message next time
      this.chatInputVal = '';
      const endBtn = document.querySelector<HTMLElement>('.chat-end-btn');
      endBtn.focus();
      const inputArea = this.el.querySelector<HTMLElement>('.chat-input');
      inputArea?.classList.replace('vs-d-flex', 'vs-d-none');
    }

    // Dispatch the event
    const chatEvent = new CustomEvent('chat_tracking_internal', {
      detail: eventDetail,
    });
    document.dispatchEvent(chatEvent);

    clearTimeout(this.chatMainMenuTimerObj);
  };

  private handleDisclaimerClose = () => {
    const disclaimerContainer = document.querySelector<HTMLElement>('.vs-chat-disclaimer-container');
    disclaimerContainer?.classList.add("vs-d-none");
    setTimeout(() => {
      this.chatContainerElement.focus();
    }, 0);
    this.isDisclaimerOpen = false;
    const inputArea = this.el.querySelector<HTMLElement>('.chat-input');
    inputArea?.classList.replace('vs-d-none', 'vs-d-flex');
    startMainMenuCounter(this);
  };

  private handleCloseDisclaimerKeyDown = (event: KeyboardEvent) => {
    if (event.key === 'Enter') {
      setTimeout(() => {
        this.chatContainerElement.focus();
      }, 0);
    }
  };

  private handleCloseKeyDown = (event: KeyboardEvent) => {
    if (event.key === 'Enter') {
      setTimeout(() => {
        this.endChatButton.focus();
      }, 500);
    }
  };


  private handleChatInput = e => {
    this.chatInputVal = e.target.value || '';
    this.textAreaOverflow = e.target.scrollHeight > e.target.clientHeight;
    clearTimeout(this.chatMainMenuTimerObj);
  };

  private applyChatBoxVisibilityClass = () => {
    if (this.isMinimized || !this.chatBoxVisible) {
      return 'vs-d-none';
    }
    return 'vs-d-block';
  };

  private emitNoResultsTrackingEvent() {
    var noResultsTrackingEvent = new CustomEvent('chat_tracking_internal', {
      detail: {
        componentType: 'button',
        eventAction: 'chat no results',
        component: 'chat assistant',
        siteSection: 'others',
        clickText: this.lastUserMessage,
      },
    });
    document.dispatchEvent(noResultsTrackingEvent);
  }

  render() {
    if (!this.isApiAuthorized) {
      return;
    }
    return (
      <div class="vs-chat-main-container" data-chat={this.chatExpansionData}>
        <div class={`vs-chat-sticky-button-container ${this.isMinimized ? 'vs-d-block' : '' || (this.chatBoxVisible && !this.isMinimized) ? 'vs-d-none' : 'vs-d-block'}`}>
          <button
            class=" vs-sticky-button"
            onClick={() => {
              toggleChatBox(this);
            }}
            aria-label={this.jsonObject.chatBotHeading}
            aria-describedby="vs-chat-dot-id"
          >
            {this.isMinimized && (
              <div class="vs-chat-dot">
                <span id="vs-chat-dot-id" class="vs-sr-only">
                  {this.chatbotAllyLabels.ongoingChatAllyLabel}
                </span>
              </div>
            )}
            <span class="vs-align-center-flex">
              {this.renderchatIcon('vs-chat-btn-icon')}
              <span class="vs-chat-btn-text" style={{ 'align-items': 'center' }}>
                {this.jsonObject.chatBotHeading}
              </span>
            </span>
          </button>
        </div>

        {this.chatBoxVisible && (
          <div
            class={`vs-chat-container ${this.animationClass} ${this.applyChatBoxVisibilityClass}`}
            ref={el => (this.chatContainerElement = el as HTMLElement)}
            aria-label={this.chatbotAllyLabels.chatWindowAllyLabel}
            tabindex="-1"
            onFocusout={e => this.handleChatFocusTrap(e)}
          >
            <div class="vs-chat-title-container">
              {this.renderchatIcon()}
              <span class="vs-chat-title-heading">{this.jsonObject.chatBotHeading}</span>
              <div class="vs-flex-align-end">
                <button onClick={() => minimizeChatbox(this)} class="visa-icon visa-icon-subtract-md vs-minimize-icon " aria-label={this.chatbotAllyLabels.minimizeButtonAllyLabel}></button>
                <button
                  onClick={this.handleChatClose}
                  class="visa-icon visa-icon-close-sm "
                  onKeyDown={this.handleCloseKeyDown}>
                  <span class="vs-sr-only">{this.chatbotAllyLabels.closeButtonAllyLabel + ' ' + this.jsonObject.endChatHeading + ' ' + this.jsonObject.endChatSubHeading}</span>
                </button>
              </div>
            </div>

            <div
              class={`chat-history ${!this.showEndChatScreen ? 'vs-d-block' : 'vs-d-none'} ${this.isLoading ? 'vs-pointer-none' : ''}`}
              ref={el => (this.chatContainer = el as HTMLInputElement)}
              aria-live="polite"
            >
              <div innerHTML={htmlSanitizer(renderBotWelcomeMessage(this.jsonObject.welcomeText, this.chatbotAllyLabels.botNameAllyLabel))}></div>
            </div>
            <div class={`chat-input ${!this.showEndChatScreen && !this.isDisclaimerOpen ? 'vs-d-flex' : 'vs-d-none'}`}>
              <textarea
                id="vs-chat-input"
                class={`${this.isLoading ? 'vs-disabled-input' : ''} vs-pt-23`}
                {...(this.isLoading && { readOnly: true })}
                onKeyUp={this.handleChatInput}
                value={this.chatInputVal}
                onFocus={(e) => {
                  // Cast to HTMLTextAreaElement to access the placeholder property
                  (e.target as HTMLTextAreaElement).placeholder = '';
                }}
                onBlur={(e) => {
                  // Cast to HTMLTextAreaElement to access the placeholder property
                  (e.target as HTMLTextAreaElement).placeholder = this.jsonObject.typeMessagePlaceholderText;
                }}
                placeholder={this.jsonObject.typeMessagePlaceholderText}
                ref={el => (this.textInput = el as any)}
                rows={3}
              />
              <div class = "vs-submit-button-container">
              <button disabled={!this.chatInputVal} class="vs-link-secondary vs-chat-enter" onClick={this.sendMessage} aria-label={this.chatbotAllyLabels.sendMessageButtonAllyLabel}>{this.renderSendIcon()}</button>
              </div>
            </div>

            <div class="vs-chat-disclaimer-container">
              <div class="vs-row vs-my-0">
                <div class="vs-text vs-attribution-text vs-mb-0 vs-col-10"
                  innerHTML={parseFromStringToHtmlElement(`<h2 class='vs-chat-title-heading'>${this.jsonObject.legalDescriptionHeading}</h2>`)}></div>
              </div>
              <div innerHTML={parseFromStringToHtmlElement(`<p class='vs-text vs-legal'>${this.jsonObject.legalDescriptionText}</p>`)}></div>
              <div class="vs-col-auto vs-disclaimer-btn-containter">
                <button
                  class="vs-btn vs-btn-primary vs-btn-icon"
                  aria-label={this.chatbotAllyLabels.disclaimerChatAllyLabel}
                  onClick={this.handleDisclaimerClose}
                  onKeyDown={this.handleCloseDisclaimerKeyDown}>I agree</button>
              </div>
            </div>

            <div class={`end-chat-history ${this.showEndChatScreen ? 'vs-d-block' : 'vs-d-none'}`}>
              <div class="vs-d-flex-align-c vs-h100 vs-flex-d-column">
                <h2 class="vs-bold-text vs-line-0">{this.jsonObject.endChatHeading}</h2>
                <span class="vs-text-align-c vs-font-size-17 vs-light-text-color">{this.jsonObject.endChatSubHeading}</span>
                <div>
                  <button
                    onClick={() => {
                      var endChatEvent = new CustomEvent('chat_tracking_internal', {
                        detail: {
                          componentType: 'button',
                          eventAction: 'end chat',
                          component: 'chat assistant',
                          siteSection: 'others',
                          clickText: 'end chat',
                        },
                      });
                      document.dispatchEvent(endChatEvent);
                      this.chatBoxVisible = !this.chatBoxVisible;
                      this.isDisclaimerOpen = true;
                      localStorage.removeItem('visaAssistSessionId');
                      const body = document.body;
                      body.classList.remove('no-page-scroll');
                      this.chatExpansionData = 'chat-closed';
                      setTimeout(() => {
                        const chatBoxEl = document.querySelector<HTMLElement>('.vs-sticky-button');
                        chatBoxEl.focus();
                      }, 100);
                    }}
                    type="button"
                    ref={el => (this.endChatButton = el as HTMLButtonElement)}
                    class="vs-btn vs-btn-primary vs-mt-20 submit-button vs-btn-icon vs-mb-2 chat-end-btn"
                  >
                    {this.jsonObject.endChatButtonText}
                  </button>
                </div>
                <div>
                  <a
                    onClick={() => (this.showEndChatScreen = false)}
                    class="vs-link-cta vs-main-menu-link vs-mt-10"
                    aria-label=""
                    target="_self"
                    data-conversiontype="Not a Conversion"
                    href="javascript:void(0)"
                  >
                    {this.jsonObject.cancelText}
                  </a>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}
